import type { NextApiRequest, NextApiResponse } from 'next'
import type { GetOrderResponse, KlarnaOrder } from 'ecosystem'
import { klarnaApiCall } from 'api'

export const klarnaPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<GetOrderResponse | { error: string }>
) => {
  const { orderId } = req.query as { orderId: string }

  if (!orderId) {
    res.status(400).json({ error: 'OrderId was not provided' })
    return
  }

  const { error, data: klarnaOrder } = await klarnaApiCall<KlarnaOrder, undefined>('get', {
    orderId
  })

  if (error || !klarnaOrder) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ klarnaResponse: klarnaOrder } as GetOrderResponse)
}
